import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import FrameworkPage from "./pages/FrameworkPage";
import ImpactPage from "./pages/ImpactPage";
import JoinPage from "./pages/JoinPage";
import ContactPage from "./pages/ContactPage";
import NorthStarPage from "./pages/NorthStarPage";
import { ScrollProgress } from "./components/Animations";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

// Page transition wrapper
function PageWrapper({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><HomePage /></PageWrapper>} />
        <Route path="/north-star" element={<PageWrapper><NorthStarPage /></PageWrapper>} />
        <Route path="/about" element={<PageWrapper><AboutPage /></PageWrapper>} />
        <Route path="/framework" element={<PageWrapper><FrameworkPage /></PageWrapper>} />
        <Route path="/impact" element={<PageWrapper><ImpactPage /></PageWrapper>} />
        <Route path="/join" element={<PageWrapper><JoinPage /></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><ContactPage /></PageWrapper>} />
        {/* Legacy routes for backward compatibility */}
        <Route path="/engines" element={<PageWrapper><FrameworkPage /></PageWrapper>} />
        <Route path="/partners" element={<PageWrapper><JoinPage /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <ScrollProgress />
        <ScrollToTop />
        <Navbar />
        <AnimatedRoutes />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
